export default "/images/TVCOM_RATING.svg?83708dd5ddd547327b349b24deb75e25";